import React from "react";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import ValeurCards from "../sections/ValeurCards";

const Valeur = ({valeurs}) => {

    return (
        valeurs.length == 0 ? <></> :
      <div className='wow fadeInUp' data-wow-delay="0.1s">
          <ValeurCards data={valeurs} icon={faAward} color={'green'} />
      </div>
    );
  };
  
  export default Valeur;